var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"not-found"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("Page not found.")])])])}]

export { render, staticRenderFns }